import { MenuCartItem } from './menu.types';

export interface MealSummary {
  name: string;
  price: number;
  count: number;
}

export interface Cart {
  id: number,
  priceSummary: PriceSummary,
  cartItems: MenuCartItem[],
  isSkipped: boolean,
  plan: Plan,
  cartUpsellVariant?: string,
  shippingAddressId: number;
  mealsSummaries: MealSummary[];
}

export interface Plan {
  name: string,
  isDiversified: boolean,
  extras: Extras,
  price: string
}

export interface Extras {
  breakfast: number,
  lunch: number,
  dinner: number,
}

export interface PriceSummary extends Coupon {
  isCouponApplied: boolean,
  extendedAreaSurcharge: string,
  shipping: string,
  subtotal: string,
  tax: string,
  total: string,
  totalDiscountAmount: string,
  remainingMinimumAmount: string,
  amountAwayFromFreeShipping: string,
  freeShippingThreshold: string,
  minimumBasePrice: string,
  userAppliedCoupon?: string,
  // Field to preserve user applied coupon after addition in backend and
  // frontend on logged out cart hash
}

export enum CartStatus {
  UNSKIPPED = 'unskipped',
  SKIPPED = 'skipped',
  SAVED = 'saved'
}

export interface Coupon {
  couponAmount: string,
  couponName: string,
  couponMessage: string,
  isCouponFreeShipping: boolean,
}
